<template>
  <div class="footer">
    <div class="container">
      <div class="columns footer__navigation call-to-action">
        <!--
                <div class="column is-half-tablet footer__newsletter">
                    <h3 class="footer__title">Newsletter Anmeldung</h3>
                    <div class="field mt-3" style="width: 50%">
                        <div class="control">
                            <input class="input" type="text">
                        </div>
                    </div>
                </div>
                -->
        <!--div class="column is-half footer__social">
          <h3 class="footer__title mb-2">{{$t('footer.newsletter.label')}}</h3>
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <label class="label is-uppercase ml-2 mb-0">{{$t('footer.newsletter.inputLabels.email')}}</label>
                            <input v-model="e_mail" @keypress.enter="showNewsletterModal = !showNewsletterModal" class="input pt-0" type="email">
                        </div>
                        <div class="control">
                            <a class="button is-rounded is-primary-dark px-6 is-medium newsletter-button" @click="showNewsletterModal = !showNewsletterModal">{{$t('footer.newsletter.inputLabels.next')}}
                                <SvgIcon icon="icon--directional_arrow-right" class="is-light ml-5"/>
                            </a>
                        </div>
                    </div>

          <b-modal v-model="showNewsletterModal" :class="{'is-active' : showNewsletterModal}" width="640px" scroll="keep" :full-screen="[viewports.MOBILE.name, viewports.TABLET.name].includes(currentViewport)" :can-cancel="['outside', 'escape']">
                        <NewsletterForm :mail-from-parent="e_mail"></NewsletterForm>
                    </b-modal>
          <h3 class="footer__title">{{ $t("footer.socialMedia.label") }}</h3>
          <div class="social__links">
            <a
              href="https://de-de.facebook.com/maagtechnic/"
              target="_blank"
              class="social-link link link-primary mr-3"
            >
              <img
                src="@/assets/img/social-media-icons/facebook.svg"
                alt="Murtfeldt Additive Solutions auf Facebook"
                title="Facebook"
              />
            </a>
            <a
              href="https://ch.linkedin.com/company/maagtechnicag"
              target="_blank"
              class="social-link link link-primary mr-5"
            >
              <img
                src="@/assets/img/social-media-icons/linkedin.svg"
                alt="Murtfeldt Additive Solutions auf LinkedIn"
                title="LinkedIn"
              />
            </a>
            <a
              href="https://www.xing.com/pages/maagtechnic"
              target="_blank"
              class="social-link link link-primary link-xing"
            >
              <img
                src="@/assets/img/social-media-icons/xing.svg"
                alt="Murtfeldt Additive Solutions auf Xing"
                title="Xing"
              />
            </a>
          </div>
        </div>
        <div
          class="column is-one-quarter-tablet footer__column"
          v-if="footerLeft"
        >
          
                    <div class="footer__title">
                        Murtfeldt Additive Solutions
                    </div>
                    <div class="navigation__links">
                        <RouterLink class="footer__link" v-for="(footerLink, childIndex) in footerLeft"
                                    :to="footerLink.link"
                                    v-bind:key="childIndex">
                            {{ footerLink.title }}
                        </RouterLink>
                         <RouterLink class="footer__link"
                                    to="/kontakt#contact-form">
                           Problem melden
                        </RouterLink>
                    </div>
                    
        </div -->
        <div
          class="column is-one-quarter-tablet footer__column"
          v-if="footerRight"
        >
          <div class="footer__title">
            {{ $t("footer.legal.label") }}
          </div>
          <div class="navigation__links">
            <a
              class="footer__link"
              :href="$t('footer.legal.links.termsAndConditions.link')"
              target="_blank"
            >
              {{ $t("footer.legal.links.termsAndConditions.text") }}
            </a>
            <a
              class="footer__link"
              :href="$t('footer.legal.links.imprint.link')"
              target="_blank"
            >
              {{ $t("footer.legal.links.imprint.text") }}
            </a>
            <a
              class="footer__link"
              :href="$t('footer.legal.links.disclaimer.link')"
              target="_blank"
            >
              {{ $t("footer.legal.links.disclaimer.text") }}
            </a>
            <a
              class="footer__link"
              :href="$t('footer.legal.links.privacy.link')"
              target="_blank"
            >
              {{ $t("footer.legal.links.privacy.text") }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__copyright">
      <div class="container">
        <div class="columns call-to-action">
          <div class="column">
            <div
              class="divider has-background-light my-4"
              style="width: 100%"
            ></div>
            <p class="is-size-7 mb-4">
              © Maagtechnic AG
              {{ new Date(Date.now()).getFullYear() }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SvgIcon from "../svg/SvgIcon";
import NewsletterForm from "../Forms/NewsletterForm";
import ModalView from "../shared/ModalView";
import { viewports } from "../../store/constants/viewports";

export default {
  name: "Footer",
  components: { SvgIcon, NewsletterForm, ModalView },
  data() {
    return {
      e_mail: "",
      showNewsletterModal: false,
      viewports,
    };
  },
  computed: {
    ...mapGetters(["cmsPage", "currentViewport"]),
    footerLeft() {
      if (this.cmsPage.page) {
        return this.cmsPage.page.navigation.footerleft;
      }
      return null;
    },
    footerRight() {
      if (this.cmsPage.page) {
        return this.cmsPage.page.navigation.footerright;
      }
      return null;
    },
  },
  methods: {
    closeModal() {
      this.showNewsletterModal = false;
    },
  },
};
</script>
